export const MODULE = {
  name: 'MaNaVi',
};
